import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import sharedReducer from './slice';
import headerReducer from 'src/features/header/store/slice';
import navReducer from 'src/features/nav/store/slice';
import footerReducer from 'src/features/footer/store/slice';

export const rootReducer = combineReducers({
  shared: sharedReducer,
  header: headerReducer,
  nav: navReducer,
  footer: footerReducer,
});

/**
 * No `serializableCheck` exceptions: every dispatch site converts the
 * AACChromeAPI configuration with `toPlainData` before it reaches a reducer.
 *
 * The store previously ignored `shared.chromeConfig._on*` so that the private
 * callbacks EmbeddedChatManager registers through AACChromeAPI —
 * `_onEmbeddedChatToggle` and `_onEmbeddedChatResize` — did not trip the check.
 * Those functions only ever arrived because one web component dispatched the
 * `ChromeConfiguration` instance itself; converting at the boundary drops them,
 * along with the class prototypes that put a `MarketplaceSwitcher` instance at
 * `shared.chromeConfig.marketplaceSwitcher`. AACChromeAPI owns and invokes the
 * callbacks and nothing reads them back out of Redux, so the store does not
 * need its own copy.
 *
 * Keeping the check at its defaults means the next unconverted dispatch site is
 * reported instead of silently ignored. See `src/app/store.test.ts`, which
 * asserts the state stays serializable under exactly this configuration.
 */
export const store = configureStore({
  reducer: rootReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
